module.exports = __webpack_public_path__ + "static/media/calendarBlack.10525745.svg";